import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FlowEvent} from '../../../shared/models';
import {EmulatorState} from '../../../shared/models/state/Emulator';

export const selectEmulator = createFeatureSelector<EmulatorState>('emulator');

export const selectFlowEvent =  createSelector(
  selectEmulator,
  (state: EmulatorState) => state.flowEvents
);

export const selectFlowEventPath =  createSelector(
  selectEmulator,
  (state: EmulatorState) => {
    const flowEvent: FlowEvent = state.flowEvents.slice(-1)[0];
    return {
      source: state.flowEvents.length > 1 ? state.flowEvents.slice(-2)[0].currentStep.step : flowEvent.currentStep.step,
      target: state.flowEvents.length > 1 ? flowEvent.currentStep.step : flowEvent.currentStep.nextStep,
      flowId: flowEvent.flowId
    };
  }
);

export const selectVariables = createSelector(
    selectEmulator,
    (emulator: EmulatorState) => {
      const flowEvent: FlowEvent = emulator.flowEvents.slice(-1)[0];
      return flowEvent ? flowEvent.variables : null;
    }
);
